import { render } from "./ViewQcmNote.vue?vue&type=template&id=94ce742c&scoped=true"
import script from "./ViewQcmNote.vue?vue&type=script&lang=js"
export * from "./ViewQcmNote.vue?vue&type=script&lang=js"

import "./ViewQcmNote.vue?vue&type=style&index=0&id=94ce742c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ce742c"]])

export default __exports__